<template>
  <DietListGroups diet-type="university" />
</template>

<script lang="ts" setup>
  import { provide } from 'vue'

  import DietListGroups from '@/components/diets/DietListGroups.vue'
  import { DietListGroupsInject } from '@/components/diets/providers/dietListGroupsProvider'
  import { useDietList } from '@/hooks/useDietList'

  provide(DietListGroupsInject, useDietList({ dietType: 'university' }))
</script>
